import { RegisteredComponent } from "@builder.io/sdk-react";

export const spinningBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Spinning block",
  canHaveChildren: true,
  defaultStyles: {
    width: "max-content",
  },
};
